import { WidgetDialogConfig } from './widget.types';

export const deleteDialogConf: WidgetDialogConfig = {
  cancelBtn: 'style.cancel',
  confirmationBtn: 'style.delete',
  sharedWidgetContent: 'style.sharedWidgetDeleteContent',
  title: 'style.confirmDeleteTitle',
  widgetContent: 'style.widgetDeleteContent',
  width: '350px',
};

export enum WidgetActionName {
  CHECK_ALL = 'check_all',
  CONFIGURE = 'configure',
  DELETE = 'delete',
  DOWNLOAD = 'download',
  REDIRECT = 'redirect',
  RELOAD = 'reload',
  SETTINGS = 'settings',
  UNCHECK_ALL = 'uncheck_all',
}
